import { Autocomplete } from '@mui/material';
import { useOldPetService } from 'service';

export default function SelectPetBlood(props) {
  const { usePetBloodOpts } = useOldPetService();
  const { data: petBloodData } = usePetBloodOpts();

  return <Autocomplete options={petBloodData || []} getOptionLabel={option => option.bloodName} {...props} />;
}
